'use strict';

export default function() {
  $(document).delegate('#updateRetailerBtn', 'click', function() {
    var url = $('#prefferedRetailerId').val();
    if (url.indexOf('=') != -1) {
      var start = url.indexOf('=');
      var length = url.length;
      var store = url.substring(start + 1, length);
      ACC.track.trackPreferredRetailer(store);
    }
    $.ajax({
      url: url,
      type: 'POST',
      success: function() {
        $('#updateRetailerDiv').css('display', 'none');
      },
    });
  });
}

function disableOrderSubmitButton() {
  $('#orderSubmitButtonV2').addClass('disabled');
  $('#orderSubmitButtonV2').prop('disabled', true);
  $('#page-loader').removeClass('hidden');
}

function enableOrderSubmitButton() {
  $('#orderSubmitButtonV2').removeClass('disabled');
  $('#orderSubmitButtonV2').removeProp('disabled');
  $('#orderSubmitButtonV2').removeAttr('disabled');
  $('#page-loader').addClass('hidden');
}

$(document).delegate('#placeOrderForm1', 'submit', function() {
  disableOrderSubmitButton();
});

function getDeviceCollectionIframeContents(jwt, url) {
  return `
         <!DOCTYPE html>
         <html>
           <head>
           </head>
           <body>
             <form id="collectionForm" name="devicedata" method="POST" action="${url}">
               <input type="hidden" name="JWT" value="${jwt}" />
             </form>
             <script>
               document.getElementById('collectionForm').submit();
             </script>
           </body>
         </html>
       `;
}

function payerAuthCompleteCheck(event) {
  // check for payerAuthComplete event data message
  return (
    event.data &&
    event.data.messageType &&
    event.data.messageType === 'payerAuthComplete' &&
    event.origin === window.location.protocol + '//' + window.location.host
  );
}

/* This listens for the postMessage from the payerAuthComplete page which lets us
  know when to close the payerAuthIframe and submit the form to the validate endpoint */
window.addEventListener(
  'message',
  function(event) {
    if (payerAuthCompleteCheck(event)) {
      // close the modal & Iframe
      $('#payer-auth-modal').foundation('close');
      // submit the form to the validate endpoint
      $('#placeOrderForm1').submit();
    }
  },
  false
);

function confirmationCompleteCheck(event) {
  // check for payerAuthComplete event data message
  return (
    event.data &&
    event.data.messageType &&
    event.data.messageType === 'confirmationValidationEvent' &&
    event.origin === window.location.protocol + '//' + window.location.host
  );
}

/* This listens for the postMessage from the confirmationValidationEvent page which lets us
  know when to close the payerAuthIframe and submit the form to the validate endpoint */
window.addEventListener(
  'message',
  function(event) {
    if (confirmationCompleteCheck(event)) {
      // handle payment rejection payer auth failure and redirect the user
      if (event.data.errorRedirectUrl) {
        $('#payer-auth-modal').foundation('close');
        window.location.replace(window.ACC.config.encodedContextPath + event.data.errorRedirectUrl);
      }
      // submit the form to the validate endpoint
      if (event.data.type !== 'false') {
        $('#payer-auth-modal').foundation('close');

        $.ajax({
          url: '/checkout/multi/summary/v2/',
          type: 'POST',
          data: $('#placeOrderForm1').serialize(),
          success: function(response) {
            if (response.data.htmlOfAutosubmitForm) {
              const wrapperSubmitForm = document.createElement('div');
              wrapperSubmitForm.innerHTML = response.data.htmlOfAutosubmitForm;
              const submitForm = wrapperSubmitForm.firstChild;
              document.body.append(submitForm);
              submitForm.submit();
            }
          },
          error: function(error) {
            $('#payer-auth-modal').foundation('close');
            enableOrderSubmitButton();
            console.log(error);
          },
        });
      } else {
        // close the modal & Iframe
        $('#payer-auth-modal').foundation('close');
        enableOrderSubmitButton();
      }
    }
  },
  false
);

$(document).ready(function() {
  // Create payer auth device collection iframe
  const jwtHolder = $('#payerAuthDeviceAccessToken');
  const deviceCollectionUrl = $('#payerAuthDeviceCollectionURL');
  if (jwtHolder && jwtHolder.val()) {
    const deviceCollectionIframe = document.createElement('iframe');
    deviceCollectionIframe.width = 1;
    deviceCollectionIframe.height = 1;
    deviceCollectionIframe.style = 'display: none';
    document.body.append(deviceCollectionIframe);
    deviceCollectionIframe.contentDocument.write(
      getDeviceCollectionIframeContents(jwtHolder.val(), deviceCollectionUrl.val())
    );
  }

  function CheckoutCompleteOrderV2() {
    /**
     * Initialize form and process with next step.
     * @param htmlCode
     */
    this.init = function(htmlCode) {
      const form = this.setupForm(htmlCode);
      if (!form) {
        throw new Error("Form doesn't exist");
      }

      if (form.classList.contains('iframe')) {
        this.initIframePopup(htmlCode);
      } else {
        form.submit();
      }
    };

    /**
     * Initialize iframe and popup.
     */
    this.initIframePopup = function(htmlCode) {
      const $modal = $('#payer-auth-modal');
      const $iframe = $('#payer-auth-iframe');

      $modal.foundation('open');
      $modal.one('closed.zf.reveal', enableOrderSubmitButton);

      $iframe
        .contents()
        .find('body')
        .html(htmlCode);

      $iframe
        .contents()
        .find('#step-up-form')
        .attr('target', '')
        .submit();
    };

    /**
     * Add form to DOM tree.
     * @param htmlCode
     * @return {ChildNode}
     */
    this.setupForm = function(htmlCode) {
      const wrapperSubmitForm = document.createElement('div');
      wrapperSubmitForm.innerHTML = htmlCode;

      const submitForm = wrapperSubmitForm.firstChild;
      document.body.append(submitForm);
      return submitForm;
    };
  }

  const placeOrderURL = window.ACC.config.encodedContextPath + '/checkout/multi/summary/v2/';
  const placeOrderSuccessResponseHandler = function(response) {
    // handle enrollment check failure and redirect the user
    if (response.data?.errorOccurred) {
      window.location.replace(
        window.ACC.config.encodedContextPath + response.data.htmlOfAutosubmitForm + response.data.errorMessages[0]
      );
    }

    if (response.data?.htmlOfAutosubmitForm) {
      const checkoutCompleteOrderV2 = new CheckoutCompleteOrderV2();
      try {
        checkoutCompleteOrderV2.init(response.data.htmlOfAutosubmitForm);
      } catch (e) {
        placeOrderErrorResponseHandler(e.message);
      }
    } else {
      placeOrderValidationErrorResponseHandler(response.meta.feedback.message.basePropertyValue);
    }
  };

  const placeOrderErrorResponseHandler = function(error) {
    enableOrderSubmitButton();
    console.log(error);
  };

  const placeOrderValidationErrorResponseHandler = function(error) {
    $('#termsErrorMessageGlobal')
      .html('<span>' + error + '</span>')
      .removeClass('hidden');
    enableOrderSubmitButton();
    console.log(error);
  };

  $('#orderSubmitButtonV2').click(function(evt) {
    evt.preventDefault();
    disableOrderSubmitButton();
    $.ajax({
      url: placeOrderURL,
      type: 'POST',
      data: $('#placeOrderForm1').serialize(),
      success: placeOrderSuccessResponseHandler,
      error: placeOrderErrorResponseHandler,
    });
  });

  // When closing the modal, re-enable the 'Place your order' button
  $('#closePayerAuthModal').click(function(evt) {
    evt.preventDefault();
    enableOrderSubmitButton();
  });
});
